import { SettingsIdValues } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { EditSettingsPage } from "~/areas/configuration/components/Settings/EditSettingsPage";
export function LDAPSettingsPage() {
    return <EditSettingsPage settingId={SettingsIdValues.LDAP}/>;
}
